export default __webpack_public_path__ + "static/media/gallery_02.97f60087.jpg";